import SegmentUtils from 'utils/segment';
import { routeToSearch } from 'router/router-utils';
import { Page } from 'utils/page-utils';
import { getRouteParam, paramNameOptions } from 'utils/url-utils';
export const onViewClickWithSegment = ({ title, destinationId, queryParams, }) => {
    SegmentUtils.track({
        event: 'Find Non-Event Parking Clicked',
        properties: {
            destination_name: title,
            destination_id: destinationId,
        },
    });
    routeToSearch({
        method: (url) => {
            window.location.replace(url);
        },
        queryParams: {
            ...queryParams,
            id: destinationId,
            kind: Page.DESTINATION,
            view: getRouteParam(paramNameOptions.VIEW),
            hide_event_modal: true,
        },
    });
};
export const showSearch = ({ destinationId, queryParams, }) => {
    routeToSearch({
        method: (url) => {
            window.location.replace(url);
        },
        queryParams: {
            ...queryParams,
            id: destinationId,
            kind: Page.DESTINATION,
            view: getRouteParam(paramNameOptions.VIEW),
            hide_event_modal: true,
        },
    });
};
